<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cXS7ta/tc-custom/9781497674417.jpg?1705692048812" alt="This image is the cover for the book Wanigan"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wanigan
      </h1>
      <p class="bookDescription body article font2">
        <b>To save his family, a logger goes down the river—and brings along his wife and daughter</b><br/><br/> When Annabel’s father sells their house in Detroit, she is thrilled by the idea of life on a farm. But when they reach their little plot of land, she sees that her daddy has been swindled. The rocky ground is hard and unforgiving, and nothing will grow there. Ruined, her father has no choice but to take the only job he can find: chopping down trees in the lush Michigan forest. For Annabel, life in the camp is dreary—but it is about to get a whole lot worse.<br/><br/> When her father is chosen to accompany the year’s load of logs as it floats down the river, Annabel and her mother take up residence in the wanigan, the floating cookshack that follows the men. This rough-hewn one-room cabin will house them for three months. As uncomfortable as it is, Annabel learns that sometimes, a river can be a home.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gloria Whelan
      </h2>
      
      <p class="authorDescription body article">&amp;lt;p&amp;gt;Gloria Whelan is the bestselling author of many novels for young readers, including &amp;lt;em&amp;gt;Homeless Bird&amp;lt;/em&amp;gt;, winner of the National Book Award; &amp;lt;em&amp;gt;Fruitlands: Louisa May Alcott Made Perfect&amp;lt;/em&amp;gt;; &amp;lt;em&amp;gt;Angel on the Square&amp;lt;/em&amp;gt;; &amp;lt;em&amp;gt;Burying the Sun&amp;lt;/em&amp;gt;; &amp;lt;em&amp;gt;Once on This Island&amp;lt;/em&amp;gt;, winner of the Great Lakes Book Award; and &amp;lt;em&amp;gt;Return to the Island&amp;lt;/em&amp;gt;. She lives in the woods of northern Michigan.&amp;lt;/p&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5931a61c